import { render, staticRenderFns } from "./ArticlesOfAssociation.vue?vue&type=template&id=1d773ebe&"
import script from "./ArticlesOfAssociation.vue?vue&type=script&lang=js&"
export * from "./ArticlesOfAssociation.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesOfAssociation.vue?vue&type=style&index=0&id=1d773ebe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports